import certificationsData from '../datas/certifications.json';
export const certifications = certificationsData;
